var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageAiSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_65_1",
    "data-name": "Component 65 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_64_1",
    "data-name": "Component 64 \\u2013 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140513",
    "data-name": "Rectangle 140513",
    width: 20,
    height: 20,
    rx: 10,
    fill: "#e2ebff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_161395",
    "data-name": "Group 161395",
    transform: "translate(3 3.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161394",
    "data-name": "Group 161394",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1949",
    "data-name": "Rectangle 1949",
    width: 12.173,
    height: 12.173,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160760",
    "data-name": "Group 160760",
    transform: "translate(0.335 1.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M5.443,6.011a6.876,6.876,0,0,1-3.6,3.6.28.28,0,0,0,0,.514,6.86,6.86,0,0,1,3.589,3.57.3.3,0,0,0,.542,0,6.873,6.873,0,0,1,3.588-3.57.279.279,0,0,0,0-.514,6.877,6.877,0,0,1-3.6-3.6.282.282,0,0,0-.518,0Z",
    transform: "translate(-1.672 -5.509)",
    fill: "none",
    stroke: "#fee3e9",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M143.7,4.183a3.883,3.883,0,0,1-1.628,1.628.312.312,0,0,0,0,.551A3.869,3.869,0,0,1,143.7,7.99a.313.313,0,0,0,.552,0,3.88,3.88,0,0,1,1.628-1.628.313.313,0,0,0,0-.551,3.89,3.89,0,0,1-1.628-1.628.313.313,0,0,0-.551,0Z",
    transform: "translate(-133.31 -4.018)",
    fill: "none",
    stroke: "#fee3e9",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-arrow-58",
    d: "M5.8,9.8,9.942,6.863,5.8,4V5.26S.987,6.33,0,10.628c2.1-2.25,5.8-2.162,5.8-2.162Z",
    transform: "translate(4.058 3.101)",
    fill: "#c9a0ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageAiSearch);
export default __webpack_public_path__ + "static/media/MessageAiSearch.8e14f0f56082d2d9ac3d8f421e0c88cb.svg";
export { ForwardRef as ReactComponent };